import { gql } from '@apollo/client/core'

export const NEW_WAITLIST_USER = gql`
  mutation newWaitlistUser($userId: String!, $eventId: String!) {
    newWaitlistUser(userId: $userId, eventId: $eventId) {
      ... on NewWaitlistUserOutput {
        success
      }
    }
  }
`
